import { render, staticRenderFns } from "./viewClient.vue?vue&type=template&id=a8daae80&scoped=true&"
import script from "./viewClient.vue?vue&type=script&lang=js&"
export * from "./viewClient.vue?vue&type=script&lang=js&"
import style0 from "./viewClient.vue?vue&type=style&index=0&id=a8daae80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8daae80",
  null
  
)

export default component.exports